<template>
  <div class="wrapper">
    <div v-if="vehicles && vehicles.length">
        <div @click="$emit('onVehicleClick', item)" class="vehicle" v-for="item in vehicles" :key="item.id">
            <div class="image">
                <app-image class="image" v-if="item.imageUrl" :imageUrl="item.imageUrl" :alt="'vehicle image'"></app-image>
                <button :disabled="disableFavorite" @click.stop="$emit('toggleFavorite', item)" class="like-btn">
                    <span class="dbc-icon dbc-icon-heart"></span>
                </button>
            </div>
            <h1 class="title">{{item.year}} {{item.make}} {{item.model}} {{item.submodel}}</h1>
            <span class="price">{{finalPrice(item.price, item.msrp)}}</span>
        </div>
    </div>
    <no-vehicles v-else :vehiclesCategory="'favorites'"></no-vehicles>
  </div>
</template>

<script>
import NoVehicles from './no-vehicles.vue'
import AppImage from '../image.vue'
import priceHelper from '../../helpers/price.helper'
export default {
  name: 'garage-vehicles-list',
  props: {
    vehicles: {
      required: true,
      default: [],
      type: Array
    },
    disableFavorite: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NoVehicles,
    'app-image': AppImage
  },
  methods: {
    finalPrice (price, msrp) {
      return priceHelper.finalPrice(price, msrp)
    }
  }
}
</script>

<style scoped>
/* .wrapper {
  box-sizing: border-box;
  padding: 0 5%;
} */
.vehicle {
  margin-bottom: 24px;
}

.image {
  position: relative;
}

.image .like-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  border: transparent;
  background: transparent;
  padding: 0;
  margin: 0;
  color: #d00000;
}

.image img {
  width: 100%;
}

.title {
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 5px;
}

.price {
  font-size: 2em;
  font-weight: 700;
  color: #2c61d5;
}
</style>



// WEBPACK FOOTER //
// garage-favorites-list.vue?0b644eb9